import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { usePermission } from '../../../../hooks/useAuth';
import Button from '../../../ui/Button';
import ScheduleList from './ScheduleList';
import CreateScheduleModal from './CreateScheduleModal';
import DeleteScheduleModal from './DeleteScheduleModal';
import { VfxSchedule } from '../../../../types';
import { PageHeader } from '@kioskgaming/ui';

const ScheduleManagement: React.FC = () => {
  const canManageVfx = usePermission('vfxConfigManagement');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [deleteSchedule, setDeleteSchedule] = useState<VfxSchedule | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  if (!canManageVfx) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <p className="text-destructive text-lg font-semibold">Access Denied</p>
          <p className="text-muted-foreground mt-2">
            You don't have permission to manage VFX schedules.
          </p>
        </div>
      </div>
    );
  }

  const handleCreateSuccess = () => {
    setShowCreateModal(false);
  };

  const handleDelete = (schedule: VfxSchedule) => {
    setDeleteSchedule(schedule);
    setShowDeleteModal(true);
  };

  const handleDeleteSuccess = () => {
    setShowDeleteModal(false);
    setDeleteSchedule(null);
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="VFX & Background Configuration"
        description="Manage scheduled VFX configurations and default settings for client websites"
        actions={
          <Button onClick={() => setShowCreateModal(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Create Schedule
          </Button>
        }
      />

      {/* Schedule List */}
      <ScheduleList onDelete={handleDelete} />

      {/* Modals */}
      {showCreateModal && (
        <CreateScheduleModal
          onClose={() => setShowCreateModal(false)}
          onSuccess={handleCreateSuccess}
        />
      )}

      {showDeleteModal && deleteSchedule && (
        <DeleteScheduleModal
          schedule={deleteSchedule}
          onClose={() => {
            setShowDeleteModal(false);
            setDeleteSchedule(null);
          }}
          onSuccess={handleDeleteSuccess}
        />
      )}
    </div>
  );
};

export default ScheduleManagement;

